import { IconChevronUp } from '@tabler/icons-react';

interface JumpLinksToggleProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  scaledIconSize: number;
  scaledFontSize: number;
  buttonStyle: React.CSSProperties;
  titleStyle: React.CSSProperties;
}

export const JumpLinksToggle = ({
  title,
  isOpen,
  onToggle,
  scaledIconSize,
  buttonStyle,
  titleStyle,
}: JumpLinksToggleProps) => (
  <button
    onClick={onToggle}
    className="flex w-full items-center"
    style={buttonStyle}
    aria-expanded={isOpen}
    aria-controls="jump-links-list"
  >
    <IconChevronUp
      size={scaledIconSize}
      className={`text-dark shrink-0 transition-transform duration-300 ${isOpen ? '' : 'rotate-180'}`}
    />
    <span className="font-base text-dark flex-1 text-left leading-[1.4] font-semibold" style={titleStyle}>
      {title}
    </span>
  </button>
);
